import { MY_HISTORY } from "../types/actions";

const initialState = {
	summary: [],
	details: []
};

export default (state = initialState, action) => {
	switch (action.type) {
		case MY_HISTORY.GET_SUMMARY:
			return { ...state, summary: action.payload };
		case MY_HISTORY.GET_DETAILS:
			return { ...state, details: action.payload };
		default:
			return state;
	}
};
